<template>
  <div>
    <a-card>
      <a-form :form="modalForm">
        <template layout="inline">
          <div>
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item label="自动审批的条件">
                  <!-- 账期 -->
                  <div>
                    <span style="margn-left: 5px">账期</span>
                    <a-radio-group
                      v-model="modalForm.lessTerm"
                      :disabled="checkDetail"
                      style="margin-left: 15px"
                      option.initialValue="2"
                    >
                      <a-radio :value="1">&lt;</a-radio>
                      <a-radio :value="2">&lt;=</a-radio>
                    </a-radio-group>
                    <a-input-number
                      controls-position="right"
                      v-model="modalForm.term"
                      :min="0"
                      :max="365"
                      :step="1"
                      maxlength="3"
                      style="width: 100px"
                      :disabled="checkDetail"
                    />
                    <span style="margn-left: 5px">天</span>
                  </div>
                </a-form-item>
                <div>
                  <span style="margn-left: 5px">额度</span>
                  <a-radio-group
                    v-model="modalForm.lessAmount"
                    :disabled="checkDetail"
                    style="margin-left: 15px"
                    option.initialValue="2"
                  >
                    <a-radio :value="1">&lt;</a-radio>
                    <a-radio :value="2">&lt;=</a-radio>
                  </a-radio-group>
                  <a-input-number
                    controls-position="right"
                    v-model="modalForm.amount"
                    :min="0"
                    :max="999999999"
                    :step="1"
                    maxlength="9"
                    style="width: 100px"
                    :disabled="checkDetail"
                  />
                  <span style="margn-left: 5px">RMB</span>
                </div>
                <div style="margin-top: 20px">
                  <span style="margn-left: 5px">业务类型</span>
                  <a-select
                    v-model="modalForm.businessId"
                    :disabled="checkDetail"
                    style="margin-left: 15px; width: 150px"
                    @change="getModel"
                  >
                    <a-select-option
                      v-for="item in selectList"
                      :key="item.value"
                    >
                      {{ item.businessName }}
                    </a-select-option>
                  </a-select>
                </div>
                <div style="margin-top: 20px">
                  <span style="margn-left: 5px">业务模式</span>
                  <a-select
                    v-model="modalForm.modelId"
                    :disabled="checkDetail || this.modalForm.businessId == 0"
                    style="margin-left: 15px; width: 150px"
                  >
                    <a-select-option
                      v-for="item in modelOptionList"
                      :key="item.id"
                    >
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </div>
              </a-col>
              <!-- <a-divider type="vertical" style="height: 200px; border-color: #7cb305" dashed /> -->
              <a-col :span="12">
                <a-form-item label="自动审批的评分卡">
                  <a-select
                    v-model="modalForm.customCardId"
                    :disabled="checkDetail"
                    style="width: 200px"
                  >
                    <a-select-option v-for="item in cardList" :key="item.id">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
                <div>
                  <a-form-item label="自动审批通过的条件">
                    <span>等 级</span>
                    <a-radio-group
                      v-model="modalForm.lessGrade"
                      :disabled="checkDetail"
                      style="margin-left: 15px"
                      :defaultValue="2"
                    >
                      <a-radio :value="1">&gt;</a-radio>
                      <a-radio :value="2">&gt;=</a-radio>
                    </a-radio-group>
                    <a-select
                      v-model="modalForm.grade"
                      :disabled="checkDetail"
                      style="width: 100px"
                    >
                      <a-select-option v-for="item in gradeList" :key="item.id">
                        {{ item.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                  <a-checkbox :disabled="checkDetail" v-model="whether">
                    判断逾期
                  </a-checkbox>

                  <!-- <a-form-item label="是否逾期">
                  <a-radio-group
                    v-decorator="$decorator('value', '是否逾期不能为空')"
                  >
                    <a-radio :value="1">是</a-radio>
                    <a-radio :value="2">否</a-radio>
                  </a-radio-group>
                </a-form-item> -->
                </div>
              </a-col>
            </a-row>
          </div>
        </template>
      </a-form>

      <div class="text-right">
        <a-button type="primary" class="add-btn" @click="saveCard" v-if="view">
          保存
        </a-button>
        <a-button type="primary" class="add-btn" @click="addCard" v-if="!view">
          编辑
        </a-button>
      </div>
    </a-card>
  </div>
</template>

<script>
import mixin from './mixin'
import {
  add,
  getTableData,
  getCardList,
  getCustomGrading,
  getBusinessTypeList,
  getRegionOptionList,
  getModelOptionList,
  getSegmentOptionList,
  getBusiness,
} from './api'
export default {
  mixins: [mixin],
  data() {
    return {
      targetData: [],
      loading: false,
      searchCardLoading: true,
      tableLoading: false,
      checkDetail: true,
      visible: true,
      view: false,
      whether: false,
      modalTitle: '',
      modalForm: {
        customCardId: null,
        term: null,
        lessTerm: null,
        grade: null,
        lessGrade: null,
        whether: null,
        lessAmount: null,
        amount: null,
        businessId: null,
        modelId: null,
      },
      // 自定义评分卡
      cardList: [],
      // 等级List
      gradeList: [],
      //设置条件
      typeList: [
        {
          id: 6,
          name: '额度',
        },
        {
          id: 7,
          name: '账期',
        },
      ],
      value: '1',
      //业务类型ID
      pid: '',
      //业务类型
      selectList: [],
      //大区
      regionOptionList: [],
      //业务模式
      modelOptionList: [],
      //法人主体
      legalOptionList: [],
      //Segment
      segmentOptionList: [],
      chooseType: '',
      chooseTypees: '',
    }
  },
  mounted() {
    // 条件列表
    this._getTableData()
    //获取业务类型下拉选
    this._getBusinessTypeList()
    // 获取等级下拉选
    this._getgradeList()
    //获取评分卡下拉选
    this._getCardList()
    //查已选择的业务类型条件
    this._getBusiness()
  },
  methods: {
    //查已选择的业务类型条件
    _getBusiness() {
      getBusiness().then(({ data }) => {
        this.pid = data.businessId
        if(this.pid != undefined && this.pid != ""){
          //获取业务模式
          this._getModelOptionList(this.pid)
        }
      })
    },
    // 获取业务类型数据
    _getBusinessTypeList() {
      getBusinessTypeList().then(({ data }) => {
        data.unshift({
          id: '0',
          name: 'All',
        })
        this.selectList = data
        this.selectList.forEach(item => {
          item.value = item.id
          item.businessName = item.name
        })
      })
    },
    //获取业务模式
    _getModelOptionList(pid) {
      getModelOptionList(pid).then(({ data }) => {
        data.unshift({
          id: '10',
          name: 'All',
        })
        this.modelOptionList = data
      })
    },

    getModel(value) {
      this.modelOptionList = null
      this.modalForm.modelId = null
      //获取业务模式
      this._getModelOptionList(value)
    },

    //获取大区
    _getRegionOptionList(pid) {
      getRegionOptionList(pid).then(({ data }) => {
        this.regionOptionList = data
      })
    },
    ///获取Segment
    _getSegmentOptionList(pid) {
      getSegmentOptionList(pid).then(({ data }) => {
        this.segmentOptionList = data
      })
    },
    // 获取等级下拉选
    _getgradeList() {
      getCustomGrading().then(({ data }) => {
        this.gradeList = data
        this.gradeList.forEach(item => {
          item.id = item.value
          item.name = item.grade
        })
      })
    },
    // 获取列表数据
    _getTableData() {
      this.tableLoading = true
      const { current, pageSize } = this.pageData
      const formData = {
        // ...this.searchForm,
        size: pageSize,
        current,
      }
      getTableData(formData).then(({ data: { total, records } }) => {
        this.pageData.total = total
        if (records[0]) {
          this.modalForm = records[0]
        }
        this.tableLoading = false
        if (this.modalForm.whether) {
          if (this.modalForm.whether == 1) {
            this.whether = true
          } else if (this.modalForm.whether == 0) {
            this.whether = false
          }
        }
      })
    },
    // 获取评分卡list
    _getCardList() {
      getCardList().then(({ data }) => {
        this.cardList = this.cardList.concat(data)
        this.cardList.forEach(item => {
          item.name = item.cardName
        })
      })
    },
    //选择条件
    async changeBusiness(value) {
      this.chooseType = value
    },
    async changeBusinesses(value) {
      this.chooseTypees = value
    },

    //编辑
    addCard() {
      this.checkDetail = false
      this.view = true
    },
    //保存
    async saveCard() {
      if (!this.id) {
        this.id = null
      }
      try {
        if (this.whether == true) {
          this.modalForm.whether = 1
        } else if (this.whether == false) {
          this.modalForm.whether = 0
        }
        if (
          this.modalForm.customCardId == null ||
          this.modalForm.term == null ||
          this.modalForm.lessTerm == null ||
          this.modalForm.grade == null ||
          this.modalForm.lessGrade == null ||
          this.modalForm.lessAmount == null ||
          this.modalForm.amount == null 
          //|| this.modalForm.businessId == null
        ) {
          this.$notification.warning({
            message: '提示',
            description: '请填写完信息',
          })
          return false
        }
        this.modalForm.id = this.id
        const { message } = await add(this.modalForm)
        this.visible = false
        this.checkDetail = true
        this.view = false
        this.$notification.success({
          message: '提示',
          description: message,
        })
        this.query()
      } catch (e) {
        console.log(e)
      }
    },
  },
}
</script>

<style scoped lang="less"></style>
